type THTTPMethods = 'GET' | 'POST';

interface IComponent {
  id: string;
  type: string;
  label?: string;
  link?: string;
  name?: string;
  placeholder?: string;
  variation?: string;
  cta?: any;
  options?: string[];
  condition?: string;
}

interface IRequest {
  path?: string;
  url?: string;
  method: THTTPMethods;
  fields?: string[];
}

interface ITriggerTracking {
  phone?: string;
  email?: string;
  token: string;
  subCategoryIds?: string[] | string;
  action?: string;
  errorMessage?: string;
}

interface IStep {
  id: string;
  title: string;
  description: string;
  components: IComponent[];
  request?: IRequest;
}

const PHONE: IStep = {
  id: 'PHONE',
  title: 'Acessar minha conta.',
  description:
    'Digite seu número de celular para gerenciar seus pacotes de moedas.',
  components: [
    {
      id: 'PHONE_phone',
      type: 'textfield_phone',
      name: 'phone',
      label: 'Celular',
      placeholder: 'Ex.: 11 99999-9999',
    },
    {
      id: 'PHONE_button',
      type: 'button',
      label: 'Continuar',
    },
  ],
  request: {
    path: `${process.env.NEXT_PUBLIC_API_PRO}/login/auth`,
    method: 'POST',
    fields: ['phone'],
  },
};

const PHONE_MFA = {
  ...PHONE,
  request: {
    ...PHONE.request,
    path: `${process.env.NEXT_PUBLIC_API_MOBILE_URL}/v1/login`,
  },
};

const CREDENTIALS_SIGNIN: IStep = {
  id: 'CREDENTIALS',
  title: 'Acesse sua conta',
  description: 'Insira os dados abaixo ou crie uma conta para continuar.',
  components: [
    {
      id: 'EMAIL_email',
      type: 'textfield_email',
      name: 'email',
      label: 'Email',
      placeholder: 'Digite o seu e-mail',
    },
    {
      id: 'EMAIL_password',
      type: 'password',
      name: 'password',
      label: 'Senha',
      placeholder: 'Digite a sua senha',
    },
    {
      id: 'EMAIL_button',
      type: 'button',
      label: 'Continuar',
    },
    {
      id: 'EMAIL_button_new',
      type: 'button_link',
      label: 'Novo no GetNinjas?',
      link: '/seja-um-profissional/login/cadastro',
      variation: 'secondary',
    },
    {
      id: 'EMAIL_button_help',
      type: 'button_link',
      label: 'Preciso de ajuda',
      link: 'https://www3.directtalk.com.br/clientes/custom/directtalk/bot/',
      variation: 'clear',
    },
  ],
  request: {
    url: `${process.env.NEXT_PUBLIC_API_MOBILE_URL}/v1/login?target=profile`,
    method: 'POST',
    fields: ['email', 'password'],
  },
};

const CODE_VALIDATION: IStep = {
  id: 'CODE_VALIDATION',
  title: '',
  description: '',
  components: [
    {
      id: 'CODE_VALIDATION_pin',
      type: 'pin',
    },
    {
      id: 'CODE_VALIDATION_button',
      type: 'button',
      label: 'Continuar',
    },
  ],
  request: {
    path: `${process.env.NEXT_PUBLIC_API_PRO}/login/validate_pin`,
    method: 'POST',
    fields: ['pin', 'validatePinURL'],
  },
};

export const LoginData = [PHONE, CODE_VALIDATION];

export const LoginDataWithCredentials = [
  PHONE_MFA,
  CREDENTIALS_SIGNIN,
  CODE_VALIDATION,
];
